import { useCallback } from 'react';

import { applyOrganizationContext } from '@/services/applyOrganizationContext';
import { trpcClient } from '@/services/trpc';

let switching = false;

export const useOrganizationChange = () => {
  return useCallback(async (value: string | undefined) => {
    if (!value || switching) return;

    switching = true;
    try {
      const result = await trpcClient.auth.switchOrganization.mutate({
        id: value,
      });
      await applyOrganizationContext({
        access: result.access,
        organizationId: result.user.currentOrganizationId,
        destination: '/',
      });
    } finally {
      switching = false;
    }
  }, []);
};
